import { SET_HOVER_LINE } from '../../../../actions/chart';

export default (state = null, action) => {
  switch (action.type) {
    case SET_HOVER_LINE:
      return action.payload.line;
    default:
      return state;
  }
};

export const getHoverLine = state => state;